import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import useHttp from "../../../../hooks/useHttp";
import { POST_ORDER_REVIEW_URL } from "../../../../utils/api-ends";
import store from "../../../../store";
import {
  canSeeGiveRatingAndReviewValue,
  orderReviewFromThisUserValue,
  thisUserGiveReviewValue,
} from "../../../../store/slices/order";

import Rating from "@mui/material/Rating";

const GiveRatingAndReview = () => {
  const [value, setValue] = useState(0);
  const [review, setReview] = useState("");
  const rating = (event, newValue) => {
    setValue(newValue);
  };
  const { error,  sendRequests } = useHttp();
  const [reviewError, setReviewError] = useState(false);
  const { orderId } = useParams();

  const onChangeReview = (e) => {
    setReview(e.target.value);
  };

  const giveReiveAndRating = (e) => {
    const formData = new FormData();
    formData.append("order_obj", orderId);
    formData.append("review_rating", value);
    formData.append("review_text", review);

    const response = (data) => {
      store.dispatch(
        orderReviewFromThisUserValue({ orderReviewFromThisUser: [data] })
      );
      store.dispatch(
        canSeeGiveRatingAndReviewValue({ canSeeGiveRatingAndReview: false })
      );
      store.dispatch(thisUserGiveReviewValue({ thisUserGiveReview: true }));
      setReviewError(false);
    };

    sendRequests(
      {
        url: POST_ORDER_REVIEW_URL,
        method: "POST",
        data: formData,
      },
      response
    );
  };

  useEffect(() => {
    if (error) {
      setReviewError(true);
    }
  }, [error]);

  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");

  return (
    <section className="order-raing-and-review">
      <div className="container theme-section">
        <h1 className="section-tittle text-center">Review And Rating</h1>

        <div className="input-box-area mb-4" single-labe="true">
          <label> Rating </label>
          <Rating
            name="simple-controlled"
            value={value}
            onChange={rating}
            className="order-rating-box"
          />

          {reviewError === true ? (
            <div
              className="error"
              show-tittle="false"
              onMouseEnter={showErrorMessage}
              onMouseLeave={hideErrorMessage}
            >
              <i className="fa-solid fa-circle-exclamation"></i>
              <p>Please Give A Rating.</p>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="input-box-area" single-labe="true">
          <label> Review </label>
          <textarea
            placeholder="Review"
            name="address"
            spellcheck="false"
            onChange={onChangeReview}
          ></textarea>
        </div>
        <div className="multiple-btn flex-direction-initial mt-4 flex-wrap">
          <button className="m-0" onClick={giveReiveAndRating}>
            {" "}
            Submit{" "}
          </button>
        </div>
      </div>
    </section>
  );
};

export default GiveRatingAndReview;
